import React from 'react';
import { Card, CardContent } from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import { Plus, CreditCard, Bitcoin, Smartphone } from 'lucide-react';

const methods = [
  { name: 'Bank Transfer', type: 'INR', icon: CreditCard, status: 'ACTIVE' },
  { name: 'UPI', type: 'INR', icon: Smartphone, status: 'ACTIVE' },
  { name: 'USDT (TRC20)', type: 'CRYPTO', icon: Bitcoin, status: 'ACTIVE' },
  { name: 'USDT (ERC20)', type: 'CRYPTO', icon: Bitcoin, status: 'ACTIVE' },
];

export default function AdminPaymentMethodsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between"><div><h1 className="text-2xl font-bold text-white">Payment Methods</h1><p className="text-sm text-slate-400">Configure deposit and withdrawal methods</p></div><Button size="sm"><Plus className="w-4 h-4 mr-1" />Add Method</Button></div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{methods.map((m, i) => {
        const Icon = m.icon;
        return (<Card key={i} className="p-5"><div className="flex items-center gap-4"><div className="w-12 h-12 bg-primary-500/10 rounded-xl flex items-center justify-center"><Icon className="w-6 h-6 text-primary-400" /></div><div className="flex-1"><h3 className="font-semibold text-white">{m.name}</h3><p className="text-sm text-slate-400">{m.type}</p></div><Badge status={m.status} /></div></Card>);
      })}</div>
    </div>
  );
}
